'use client';
import HeaderLeagueButtons from '@/modules/league/new-components/header/HeaderLeagueButtons/HeaderLeagueButtons';

interface HeaderLeagueButtonsClientProps {
  slug: string;
  sessionId: string;
  matchDateId: string;
  leagueId: string;
}

const HeaderLeagueButtonsWrapper = ({
  slug,
  sessionId,
  matchDateId,
  leagueId,
}: HeaderLeagueButtonsClientProps) => {
  return (
    <HeaderLeagueButtons
      slug={slug}
      sessionId={sessionId}
      leagueId={leagueId}
      matchDateId={matchDateId}
    />
  );
};

export default HeaderLeagueButtonsWrapper;
